import { IconButton, type IconButtonProps, Badge } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';

interface NotificationsButtonProps extends IconButtonProps {
  unreadCount?: number;
}

export function NotificationsButton({ unreadCount = 0, ...iconButtonProps }: NotificationsButtonProps) {
  return (
    <IconButton {...iconButtonProps}>
      <Badge badgeContent={unreadCount} color="error" max={99}>
        <NotificationsIcon />
      </Badge>
    </IconButton>
  );
}
